"use strict";

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./redux-saga-core.prod.cjs.js')
} else {
  module.exports = require('./redux-saga-core.dev.cjs.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/@redux-saga/core/dist/redux-saga-core.cjs.js
// module id = 272
// module chunks = 0